import React from 'react';
import { states } from '@/constants/lifecycle';
import { fetchConfig } from '@/hooks/fetch';
import WorkflowFetch from '@/workflows/hooks/fetch';
import { hasMinimumLength } from '@/utils/resultsHelper';
import RequestPanelContainerContent from './RequestPanelContainerContent';
import RequestMarkdownFallback from '../markdown/components/RequestMarkdownFallback';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const RequestPanelExistingContainer = ({
  category,
  className,
  code,
  children,
  compact,
  onChange,
  url,
}) => {
  const { readStatus, workflowKey, workflowReadStatus } = Selectors.useRequestPanelContainer({ category, code });
  const hasSource = hasMinimumLength(workflowKey);
  Fetch.useFetchRequest({ category, code }, readStatus);
  WorkflowFetch.useFetchWorkflow(
    { category, code: workflowKey },
    workflowReadStatus,
    fetchConfig([workflowKey], () => hasSource && readStatus === states.SUCCESS),
  );

  const content = !hasSource && readStatus === states.SUCCESS
    ? <RequestMarkdownFallback category={category} code={code} />
    : children;

  return (
    <RequestPanelContainerContent
      category={category}
      className={className}
      code={code}
      compact={compact}
      onChange={onChange}
      url={url}
    >
      {content}
    </RequestPanelContainerContent>
  );
};

export default RequestPanelExistingContainer;
